    
<template>
    <div class="dashBox">
        <div class="dashTitle">
            <a-spin :spinning="chartloading"></a-spin>
            <span>异常趋势图</span><span style="color:#333;font-size:12px;padding-left:20px;">   异常总数：{{sumChartValue}}</span>
            <a-select mode="default" v-model="chartPerTime" @change="handleChartPerTimeChange" style="width: 80px;float:right;margin-top:2px;" placeholder="请选择时间">
                <a-select-option v-for="(value,name) in perTimeValue" :key="name" :value="name">
                    {{name}}
                </a-select-option>
            </a-select>
        </div>
        <a-empty v-if="chartDate.length == 0" description="暂无数据" style="margin-top:80px;" />

        <div id="trendItemChart" style="width: 100%;padding-top:10px;"></div>
    </div>
</template>

<script>
const perTimeValue = {
    '1秒':'1s',
    '1分钟':'1m',
    '5分钟':'5m',
    '10分钟':'10m',
    '1小时':'1h',
    '1天':'1d',
}
export default {
    data() {
        return {
            chartValue:[],
            chartDate:[],
            seriesList:[],
            listthread:[],
            chartSys:null,
            perTimeValue,
            chartPerTime:'1分钟',
            sumChartValue:0,

            keyword:'',
            starttime:'',
            endtime:'',
            projectname:'',
            logstorename:'',
            chartloading:false
        }
    },

    methods: {
        handleChartPerTimeChange(){
            this.loadData(this.keyword,this.starttime,this.endtime,this.projectname,this.logstorename);
        },
        loadData(keyword,starttime,endtime,projectname,logstorename,chartPerTime){
            this.keyword = keyword;
            this.starttime = starttime;
            this.endtime = endtime;
            this.projectname = projectname;
            this.logstorename = logstorename;
            this.chartPerTime = chartPerTime;
            let perN = this.perTimeValue[this.chartPerTime];
            let queryStr = "* | select count(1) as count,time_series(__time__, '"+perN+"', '%Y-%m-%d %H:%i:%s' ,'0') as occurtime from log where message like '%"+keyword+"%' group by occurtime order by occurtime";
            let that = this;
            that.chartloading = true;
            let params = {
                projectname:projectname,
                logstorename:logstorename,
                starttime:starttime,
                endtime:endtime,
                sql:queryStr,
                pageSize:100,
                offset:0,
                reverse:false,
                paged:false,
                timeout:15000,
                urlparams:false
            };
            that.$store.dispatch({
                type: "logservice/querylog",
                params:params
            }).then((res)=>{
                if(res.status == 200 && res.data.success == '1'){

                    let result = res.data.data;
                    let array = result.list;
                    that.chartDate = [];
                    that.chartValue = [];
                    that.sumChartValue = 0;
                    for (let index = 0; index < array.length; index++) {
                        const element = array[index];
                        let tempTime = "";
                        if(this.chartPerTime == '1秒'){
                            tempTime = (new Date(element.occurtime)).Format('MM-dd hh:mm:ss');
                        }
                        else{
                            tempTime = (new Date(element.occurtime)).Format('MM-dd hh:mm');
                        }

                        that.chartDate.push(tempTime);
                        that.chartValue.push(element.count)
                        that.sumChartValue += parseInt(element.count);
                    }

                    that.analystData();

                    
                }
                that.chartloading = false;
            }).catch(() => {
                that.chartloading = false;
            });
        },
        //按日期统计数据
        analystData(){
            let that = this;
            if(that.chartSys){
                that.chartSys.clear();
            }
            document.getElementById("trendItemChart").style.height = "360px";
            that.chartSys = that.$echarts.init(document.getElementById("trendItemChart"));
            
            let option = that.getDatailOption();
            // 窗口大小自适应方案
            that.chartSys.setOption(option);
            that.chartSys.off('click');
            that.chartSys.on('click', function () {
            });
            
        },
        getDatailOption(){
            let that = this;
            let option = {
                xAxis: {
                    type: 'category',
                    data: that.chartDate.map(function (str) {
                        return str.replace(' ', '\n');
                    })
                },
                color:that.G.getChartColors(),
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        label: {
                            backgroundColor: '#6a7985'
                        }
                    }
                },
                yAxis: {
                    type: 'value'
                },
                series: [{
                    data: that.chartValue,
                    type: 'line',
                    smooth: true
                }]
            };
            return option;
        },
        chartResize(){
            let eleArr = [this.chartSys];
            for(let i = 0; i<eleArr.length; i++){
                //此处定时器是为了在页面存在多个图时，resize方法的调用时间微微错开，避免明显的卡顿
                setTimeout(function(){
                    if(eleArr[i]){
                        eleArr[i].resize();
                    }
                }, 200);
            }
        },
    },
    mounted() {
        window.addEventListener("resize", this.chartResize);
    },
    destroyed(){
        window.removeEventListener("resize", this.chartResize);

    },

}
</script>

<style scoped>

    .dashBox{
        min-height: 395px;
        border: 1px solid lightgray;
        padding-bottom: 20px;
        background-color: white;
    }
    .dashTitle{
        width: 100%;
        height: 40px;
        color: #00c1de;
        line-height:38px;
        padding:0 10px;
        border-bottom: 1px solid lightgray;
        cursor: default;
    }
</style>
